<template>
  <v-content>
    <Header></Header>
    <!-- Tab -->
    <v-layout v-if="$vuetify.breakpoint.smAndUp">
      <v-flex xs12>
        <v-card flat class="mt-6">
          <v-tabs
            color="#FD5246"
            background-color="#F8F8F8"
            v-model="active_tab"
            light
            centered
            icons-and-text
          >
            <v-tab
              v-for="tab in tabs"
              :key="tab.id"
              :href="`#tab-${tab.id - 1}`"
              @click="$router.push(tab.link)"
            >
              <v-layout>
                <v-flex class="mr-4 d-flex justify-center align-center">
                  <v-icon style="font-size: 50px">{{ tab.icon }}</v-icon>
                </v-flex>
                <v-flex
                  :style="
                    tab.name === 'portfolio_profile'
                      ? { 'font-size': '20px', color: '#575757' }
                      : { 'font-size': '20px', color: '#FD5246' }
                  "
                  class="d-flex justify-center align-center"
                >
                  {{ $t(tab.name) }}
                </v-flex>
              </v-layout>
            </v-tab>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-else>
      <v-flex xs12 my-4>
        <v-layout class="text-center">
          <v-flex
            class="main-menu-hover"
            @click="$router.push('/profile-portfolio')"
          >
            <v-icon large>menu_book</v-icon>
            <div>
              PORTFOLIO
            </div>
          </v-flex>
          <v-flex class="main-menu-hover main-menu-active">
            <v-icon large color="#FD5246">account_circle</v-icon>
            <div>
              ABOUT
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-hover v-slot:default="{ hover }">
      <div
        style="width: 100%; position: relative"
        :style="{ height: $vuetify.breakpoint.smAndDown ? '120px' : '180px' }"
      >
        <!-- <img
          width="100%"
          height="100%"
          style="position: absolute; object-fit: cover; filter: blur(4px);"
          :src="
            personalInfo.mem_info
              ? checkImage(personalInfo.mem_info, 'cover_url')
              : require('../assets/cover.png')
          "
        /> -->
        <v-layout justify-center style="height: 100%">
          <v-flex>
            <v-img
              height="100%"
              @click="
                $vuetify.breakpoint.mdAndUp
                  ? onSelectCover('desktop')
                  : onSelectCover()
              "
              :src="
                personalInfo.mem_info
                  ? checkImage(personalInfo.mem_info, 'cover_url')
                  : require('../assets/cover.png')
              "
              v-if="coverReload"
            ></v-img>
          </v-flex>
        </v-layout>
        <v-expand-transition>
          <div
            v-if="hover"
            @click="onSelectCover()"
            class="d-flex transition-fast-in-fast-out black white--text txt-head hover_img"
          >
            <v-icon dark class="mr-2">edit</v-icon>
            {{ $t("edit") }}
          </div>
        </v-expand-transition>
        <input
          ref="cover"
          type="file"
          class="d-none"
          accept="image/*"
          @change="onCoverChanged"
        />
      </div>
    </v-hover>

    <v-layout
      justify-center
      pt-7
      style="background-color: #F8F8F8;margin-bottom: 8rem"
    >
      <v-flex xs11 sm10 lg9>
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
          <!-- Profile -->
          <v-card
            flat
            class="pa-5 py-md-5 px-md-12  pb-3"
            style="border: solid 1px #C4C4C4; border-radius: 10px 10px 0 0; border-bottom: none"
          >
            <v-layout justify-center>
              <v-flex>
                <img
                  width="70px"
                  class="ma-4"
                  style="position: absolute; right: 0; top: 0;"
                  :src="require('../assets/tcdc-color.png')"
                />
                <v-layout>
                  <v-flex shrink txt-head>
                    {{ $t("personal-info") }}
                  </v-flex>
                </v-layout>
                <v-divider class="my-5"></v-divider>
                <div
                  :class="{ 'flex-center': $vuetify.breakpoint.smAndDown }"
                  :style="{
                    position: $vuetify.breakpoint.mdAndUp ? 'absolute' : '',
                  }"
                  class="pt-5 pt-md-3"
                >
                  <div style="width: 90px; height: 90px">
                    <v-hover v-slot:default="{ hover }">
                      <v-img
                        width="100%"
                        height="100%"
                        @click="
                          $vuetify.breakpoint.mdAndUp
                            ? onSelectProfile('desktop')
                            : onSelectProfile()
                        "
                        style="border-radius: 100%; object-fit: cover;"
                        :src="
                          personalInfo.mem_info
                            ? checkImage(personalInfo.mem_info, 'avatar')
                            : require('../assets/user_profile.png')
                        "
                        v-if="profileReload"
                      >
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            @click="onSelectProfile()"
                            class="d-flex transition-fast-in-fast-out black white--text hover_img"
                          >
                            <v-icon dark x-small class="ml-n1 mr-1"
                              >edit</v-icon
                            >
                            {{ $t("edit") }}
                          </div>
                        </v-expand-transition>
                      </v-img>
                    </v-hover>
                    <input
                      ref="profile"
                      type="file"
                      class="d-none"
                      accept="image/*"
                      @change="onProfileChanged"
                    />
                  </div>
                </div>
                <v-layout justify-center>
                  <v-flex xs12 sm11 md8>
                    <span class="font-weight-bold"
                      >{{ $t("first-name") }}
                      <span class="red--text txt-detail">*</span></span
                    >
                    <v-text-field
                      dense
                      solo
                      flat
                      v-model="personalInfo.name_th"
                      class="mt-2 radius8"
                    ></v-text-field>

                    <span class="font-weight-bold"
                      >{{ $t("last-name") }}
                      <span class="red--text txt-detail">*</span></span
                    >
                    <v-text-field
                      dense
                      solo
                      flat
                      v-model="personalInfo.last_th"
                      class="mt-2 radius8"
                    ></v-text-field>

                    <span class="font-weight-bold">{{ $t("bio") }}</span>
                    <v-text-field
                      dense
                      solo
                      flat
                      v-model="personalInfo.mem_info.bio"
                      class="mt-2 radius8"
                    ></v-text-field>

                    <span class="font-weight-bold">{{ $t("place") }}</span>
                    <v-text-field
                      dense
                      solo
                      flat
                      v-model="personalInfo.mem_info.location"
                      class="mt-2 radius8"
                    ></v-text-field>

                    <span class="font-weight-bold"
                      >{{ $t("brand-name") }}
                      <span class="red--text txt-detail"
                        >( {{ $t("if-any") }} )</span
                      >
                    </span>
                    <v-text-field
                      dense
                      solo
                      flat
                      v-model="personalInfo.mem_info.brand_name"
                      class="mt-2 radius8"
                    ></v-text-field>

                    <span class="font-weight-bold">{{ $t("job") }}</span>
                    <v-text-field
                      dense
                      solo
                      flat
                      v-model="personalInfo.mem_info.profession"
                      class="mt-2 radius8"
                    ></v-text-field>
                    <!--                  <v-autocomplete dense solo flat :items="jobs" v-model="personalInfo.profession" class="mt-2 radius8"></v-autocomplete>-->

                    <span class="font-weight-bold">{{
                      $t("design-type")
                    }}</span>
                    <v-text-field
                      dense
                      solo
                      flat
                      v-model="personalInfo.mem_info.design_type"
                      class="mt-2 radius8"
                    ></v-text-field>
                    <!--                  <v-autocomplete dense solo flat :items="design_type" v-model="personalInfo.design_type" class="mt-2 radius8"></v-autocomplete>-->

                    <span class="font-weight-bold"
                      >{{ $t("email") }}
                      <span class="red--text txt-detail"></span
                    ></span>
                    <v-text-field
                      disabled
                      dense
                      solo
                      flat
                      v-model="personalInfo.email"
                      class="mt-2 radius8"
                    ></v-text-field>

                    <span class="font-weight-bold">{{
                      $t("phone-number")
                    }}</span>
                    <v-text-field
                      dense
                      solo
                      flat
                      v-model="personalInfo.mobile_number"
                      class="mt-2 radius8"
                      required
                      :rules="phoneRules"
                    ></v-text-field>

                    <span class="font-weight-bold">{{ $t("website") }}</span>
                    <v-text-field
                      dense
                      solo
                      flat
                      v-model="personalInfo.mem_info.website"
                      class="mt-2 radius8"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>

          <!-- Social -->
          <v-card
            flat
            class="pa-5 pa-md-7 pt-8 mb-5"
            style="background: #DFDFDF; border: solid 1px #C4C4C4; border-radius: 0 0 10px 10px; border-top: none"
          >
            <v-layout justify-center mb-3>
              <v-flex xs12 lg11>
                <v-layout justify-center>
                  <v-flex xs12 sm11 md8>
                    <v-layout justify-space-between>
                      <v-flex>
                        <v-layout
                          style="position: relative"
                          :class="{ column: $vuetify.breakpoint.smAndDown }"
                        >
                          <span
                            class="red--text txt-detail pt-lg-2"
                            style="position: absolute;"
                            :class="{
                              'left-sm-and-up': $vuetify.breakpoint.smAndUp,
                              'left-xs': $vuetify.breakpoint.xs,
                            }"
                          >
                            *
                          </span>
                          <v-flex
                            shrink
                            pt-lg-2
                            mr-2
                            :class="{ 'mb-2': $vuetify.breakpoint.smAndDown }"
                          >
                            <span class="font-weight-bold">Domain :</span>
                            connect.cea.or.th/profile/
                          </v-flex>
                          <v-flex shrink>
                            <v-layout>
                              <v-flex mr-2>
                                <v-text-field
                                  :rules="domainRules"
                                  dense
                                  solo
                                  flat
                                  v-model="personalInfo.mem_info.domain_name"
                                  class="radius8"
                                ></v-text-field>
                              </v-flex>
                              <v-flex shrink>
                                <v-btn
                                  @click="checkDomain"
                                  outlined
                                  color="red"
                                  style="display: inline-block"
                                  >{{ $t("check") }}
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      justify-space-between
                      :class="{ column: $vuetify.breakpoint.smAndDown }"
                    >
                      <v-flex
                        pt-md-2
                        :class="{ 'mb-2': $vuetify.breakpoint.smAndDown }"
                        shrink
                      >
                        <span class="font-weight-bold">Facebook : </span>
                        www.facebook.com/
                      </v-flex>
                      <v-flex ml-md-2>
                        <v-text-field
                          dense
                          solo
                          flat
                          v-model="personalInfo.mem_info.facebook"
                          class="radius8"
                          style="width: 100%; display: inline-block"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      justify-space-between
                      :class="{ column: $vuetify.breakpoint.smAndDown }"
                    >
                      <v-flex
                        shrink
                        pt-2
                        :class="{ 'mb-2': $vuetify.breakpoint.smAndDown }"
                      >
                        <span class="font-weight-bold">Instagram : </span>
                      </v-flex>
                      <v-flex ml-md-2>
                        <v-text-field
                          dense
                          prefix="@"
                          solo
                          flat
                          v-model="personalInfo.mem_info.instagram"
                          class="radius8"
                          style="width: 100%;; display: inline-block"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      justify-space-between
                      :class="{ column: $vuetify.breakpoint.smAndDown }"
                    >
                      <v-flex
                        shrink
                        pt-2
                        :class="{ 'mb-2': $vuetify.breakpoint.smAndDown }"
                      >
                        <span class="font-weight-bold">Twitter : </span>
                      </v-flex>
                      <v-flex ml-md-2>
                        <v-text-field
                          dense
                          solo
                          flat
                          v-model="personalInfo.mem_info.twitter"
                          class="radius8"
                          style="width: 100%;; display: inline-block"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      justify-space-between
                      :class="{ column: $vuetify.breakpoint.smAndDown }"
                    >
                      <v-flex
                        shrink
                        pt-2
                        font-weight-bold
                        :class="{ 'mb-2': $vuetify.breakpoint.smAndDown }"
                      >
                        Pinterest :
                      </v-flex>
                      <v-flex ml-md-2>
                        <v-text-field
                          dense
                          solo
                          flat
                          v-model="personalInfo.mem_info.pinterest"
                          class="radius8"
                          style="width: 100%; display: inline-block"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout justify-center>
              <v-flex shrink>
                <v-btn
                  large
                  color="#FD5246"
                  width="160px"
                  depressed
                  @click="updatePersonalInfo"
                  :dark="valid"
                  :disabled="!valid"
                  :loading="btnPersonalIsLoading"
                >
                  {{ $t("save") }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-form>

        <!-- Education -->
        <v-expansion-panels
          flat
          class="mb-5 radius10"
          style="border: solid 1px #C4C4C4"
        >
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-layout justify-center>
                <v-flex xs11 txt-head>
                  {{ $t("education-info") }}
                </v-flex>
              </v-layout>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-if="mode === 'update'">
              <v-layout justify-center>
                <v-flex md11>
                  <v-form
                    ref="formEducation"
                    v-model="validEducation"
                    lazy-validation
                  >
                    <v-divider class="mb-10 mb-md-5"></v-divider>
                    <v-layout
                      class="mb-6"
                      justify-space-between
                      style="position: relative"
                      :class="{ column: $vuetify.breakpoint.smAndDown }"
                      v-for="(item, i) in personalInfo.educations"
                      :key="i"
                    >
                      <v-flex xs4 mr-md-3>
                        {{ $t("school") }}
                        <v-text-field
                          :rules="requireRules"
                          dense
                          solo
                          flat
                          class="mt-2 radius8"
                          v-model="item.school_university"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4 mr-md-3>
                        {{ $t("degree") }}
                        <v-text-field
                          :rules="requireRules"
                          dense
                          solo
                          flat
                          class="mt-2 radius8"
                          v-model="item.degree_id"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        {{ $t("branch") }}
                        <v-text-field
                          :rules="requireRules"
                          dense
                          solo
                          flat
                          class="mt-2 radius8"
                          v-model="item.class_of"
                        ></v-text-field>
                      </v-flex>

                      <!-- btn remove desktop -->
                      <v-btn
                        v-if="$vuetify.breakpoint.mdAndUp"
                        icon
                        dark
                        color="#828282"
                        depressed
                        :absolute="$vuetify.breakpoint.mdAndUp"
                        style="z-index: 10"
                        class="mt-7 mt-md-0"
                        :class="{ removeBtnPos: $vuetify.breakpoint.mdAndUp }"
                        @click="removeEducationInfo(item.id)"
                      >
                        <v-icon>remove_circle</v-icon>
                      </v-btn>

                      <!-- btn remove desktop -->
                      <v-btn
                        v-else
                        dark
                        color="#828282"
                        depressed
                        :class="{ removeBtnPos: $vuetify.breakpoint.mdAndUp }"
                        @click="removeEducationInfo(item.id)"
                      >
                        <v-icon>remove_circle</v-icon>
                      </v-btn>
                    </v-layout>

                    <!-- Btn Add desktop -->
                    <v-layout
                      v-if="$vuetify.breakpoint.mdAndUp"
                      mt-7
                      mt-md-0
                      style="position: relative; height: 90px"
                      :class="{
                        'justify-end': $vuetify.breakpoint.smAndDown,
                        'mt-n9': $vuetify.breakpoint.smAndDown,
                      }"
                    >
                      <span
                        v-if="$vuetify.breakpoint.mdAndUp"
                        style="color:#72C3B6; position: absolute;"
                        :style="[
                          personalInfo.educations.length === 0
                            ? { top: '35px', right: '5px' }
                            : { top: '30px', right: '0' },
                        ]"
                        >{{ $t("add") }}</span
                      >
                      <span v-else style="color:#72C3B6;" class="mr-1 pt-1">{{
                        $t("add")
                      }}</span>
                      <v-btn
                        icon
                        dark
                        :large="personalInfo.educations.length === 0"
                        color="#72C3B6"
                        depressed
                        :absolute="$vuetify.breakpoint.mdAndUp"
                        :class="{ addBtnPos: $vuetify.breakpoint.mdAndUp }"
                        @click="addEducationInfo"
                      >
                        <v-icon :large="personalInfo.educations.length === 0"
                          >add_circle</v-icon
                        >
                      </v-btn>
                    </v-layout>

                    <!-- Btn Add Mobile -->
                    <v-layout class="my-10" v-else>
                      <v-flex xs12 class="flex-center">
                        <v-btn
                          width="100%"
                          dark
                          color="#72C3B6"
                          @click="addEducationInfo"
                        >
                          <v-icon> add_circle</v-icon>
                          <!-- {{ $t("add") }} -->
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-flex>
              </v-layout>
              <v-layout justify-center>
                <v-flex shrink>
                  <v-btn
                    large
                    color="#FD5246"
                    width="160px"
                    depressed
                    :dark="validEducation"
                    :disabled="!validEducation"
                    @click="updateEducationInfo"
                    :loading="btnEducationIsLoading"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
            <v-expansion-panel-content v-else>
              <div class="d-flex justify-center" style="opacity: .5">
                {{ $t("please-save") }}
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- Work Exp -->
        <v-expansion-panels
          flat
          class="mb-5 radius10"
          style="border: solid 1px #C4C4C4"
        >
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-layout justify-center>
                <v-flex xs11 txt-head>
                  {{ $t("work-exp") }}
                </v-flex>
              </v-layout>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-if="mode === 'update'">
              <v-layout justify-center>
                <v-flex md11>
                  <v-form ref="formWork" v-model="validWork" lazy-validation>
                    <v-divider class="mb-10 mb-md-5"></v-divider>
                    <v-layout
                      justify-space-between
                      class="mb-8"
                      style="position: relative"
                      :class="{ column: $vuetify.breakpoint.smAndDown }"
                      v-for="(item, i) in personalInfo.works"
                      :key="i"
                    >
                      <v-flex xs4 mr-md-3>
                        {{ $t("company") }}
                        <v-text-field
                          :rules="requireRules"
                          dense
                          solo
                          flat
                          class="mt-2 radius8"
                          v-model="item.company"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4 mr-md-3>
                        {{ $t("position") }}
                        <v-text-field
                          :rules="requireRules"
                          dense
                          solo
                          flat
                          class="mt-2 radius8"
                          v-model="item.position"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        {{ $t("place") }}
                        <v-text-field
                          :rules="requireRules"
                          dense
                          solo
                          flat
                          class="mt-2 radius8"
                          v-model="item.city"
                        ></v-text-field>
                      </v-flex>

                      <!-- btn work desktop -->
                      <v-btn
                        v-if="$vuetify.breakpoint.mdAndUp"
                        icon
                        dark
                        color="#828282"
                        depressed
                        :absolute="$vuetify.breakpoint.mdAndUp"
                        style="z-index: 10"
                        class="mt-7 mt-md-0"
                        :class="{ removeBtnPos: $vuetify.breakpoint.mdAndUp }"
                        @click="removeWorkExperience(item.id)"
                      >
                        <v-icon>remove_circle</v-icon>
                      </v-btn>

                      <!-- btn work mobile -->
                      <v-btn
                        v-else
                        dark
                        color="#828282"
                        depressed
                        @click="removeWorkExperience(item.id)"
                      >
                        <v-icon>remove_circle</v-icon>
                      </v-btn>
                    </v-layout>

                    <!-- btn add work desktop -->
                    <v-layout
                      v-if="$vuetify.breakpoint.mdAndUp"
                      mt-7
                      mt-md-0
                      style="position: relative; height: 90px"
                      :class="{
                        'justify-end': $vuetify.breakpoint.smAndDown,
                        'mt-n9': $vuetify.breakpoint.smAndDown,
                      }"
                    >
                      <span
                        style="color:#72C3B6; position: absolute;"
                        :style="[
                          personalInfo.educations.length === 0
                            ? { top: '35px', right: '5px' }
                            : { top: '30px', right: '0' },
                        ]"
                        >{{ $t("add") }}</span
                      >
                      <v-btn
                        icon
                        dark
                        :large="personalInfo.works.length === 0"
                        color="#72C3B6"
                        depressed
                        :absolute="$vuetify.breakpoint.mdAndUp"
                        :class="{ addBtnPos: $vuetify.breakpoint.mdAndUp }"
                        @click="addWorkExperience"
                      >
                        <v-icon :large="personalInfo.works.length === 0"
                          >add_circle</v-icon
                        >
                      </v-btn>
                    </v-layout>

                    <!-- btn add work mobile -->
                    <v-layout my-10 v-else>
                      <v-btn
                        width="100%"
                        dark
                        color="#72C3B6"
                        depressed
                        @click="addWorkExperience"
                      >
                        <v-icon :large="personalInfo.works.length === 0"
                          >add_circle</v-icon
                        >
                      </v-btn>
                    </v-layout>
                  </v-form>
                </v-flex>
              </v-layout>
              <v-layout justify-center>
                <v-flex shrink>
                  <v-btn
                    large
                    color="#FD5246"
                    width="160px"
                    depressed
                    :dark="validWork"
                    :disabled="!validWork"
                    @click="updateWorkInfo"
                    :loading="btnWorkIsLoading"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
            <v-expansion-panel-content v-else>
              <div class="d-flex justify-center" style="opacity: .5">
                {{ $t("please-save") }}
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- Portfolios -->
        <v-expansion-panels
          flat
          class="mb-8 radius10"
          style="border: solid 1px #C4C4C4;"
        >
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-layout justify-center>
                <v-flex xs11 txt-head>
                  {{ $t("portfolio") }}
                </v-flex>
              </v-layout>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-if="mode === 'update'">
              <v-layout justify-center>
                <v-flex md11>
                  <v-layout justify-end mr-3>
                    <v-flex shrink>
                      <v-btn
                        dark
                        depressed
                        color="#72C3B6"
                        @click="$router.push('/create-portfolio')"
                      >
                        <v-icon class="mr-2">add</v-icon>
                        {{ $t("add") }}
                      </v-btn>
                    </v-flex>
                  </v-layout>

                  <!-- Data table -->
                  <v-layout
                    v-resize="onResize"
                    column
                    class="mt-12 mt-sm-4 mt-md-12 mt-lg-12"
                  >
                    <v-data-table
                      :headers="worksHeaders"
                      :items="allPortfolio"
                      :search="search"
                      :hide-headers="isMobile"
                      :class="{ mobile: isMobile }"
                    >
                      <template v-slot:item="{ item }">
                        <tr v-if="!isMobile">
                          <td>{{ item.project_title }}</td>
                          <td>
                            {{
                              item.portfolio_cate
                                ? item.portfolio_cate.name_th
                                : "-"
                            }}
                          </td>
                          <td>{{ item.project_brief }}</td>
                          <td>
                            {{ item.updated_at | moment("DD/MM/YYYY HH:mm") }}
                          </td>
                          <td>
                            <v-icon
                              small
                              class="mr-2"
                              @click="onEdit(item.portfolio_id)"
                            >
                              edit
                            </v-icon>
                            <v-icon small @click="onDelete(item.portfolio_id)">
                              delete
                            </v-icon>
                          </td>
                        </tr>

                        <tr v-else>
                          <!-- <td> -->
                          <v-layout
                            class="py-4"
                            column
                            style="font-size: 14px;width: 290px"
                          >
                            <v-flex class="flex-item mb-2">
                              <span style="font-weight: bold"
                                >{{ $t("port-name") }} :</span
                              >
                              {{ item.project_title }}
                            </v-flex>
                            <v-flex class="flex-item mb-2">
                              <span style="font-weight: bold"
                                >{{ $t("category") }} :</span
                              >
                              {{
                                item.portfolio_cate
                                  ? item.portfolio_cate.name_th
                                  : "-"
                              }}
                            </v-flex>
                            <v-flex style="width: 600px" mb-2>
                              <span style="font-weight: bold"
                                >{{ $t("img-desc") }} :</span
                              >
                              {{ item.project_brief }}
                            </v-flex>
                            <v-flex class="flex-item mb-2">
                              <span style="font-weight: bold">
                                {{ $t("updated-at") }} :</span
                              >
                              {{ item.updated_at | moment("DD/MM/YYYY HH:mm") }}
                            </v-flex>
                            <v-flex class="mb-2">
                              <span style="font-weight: bold" class="mr-4">
                                {{ $t("edit") }} :
                              </span>
                              <v-btn
                                style="margin-right: 2rem"
                                dark
                                depressed
                                color="#4CBF33"
                              >
                                <v-icon @click="onEdit(item.portfolio_id)">
                                  edit
                                </v-icon>
                              </v-btn>

                              <v-btn dark depressed color="#FF0000">
                                <v-icon @click="onDelete(item.portfolio_id)">
                                  delete
                                </v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                          <!-- </td> -->
                        </tr>
                      </template>
                      <v-alert
                        slot="no-results"
                        :value="true"
                        color="error"
                        icon="warning"
                      >
                        Your search for "{{ search }}" found no results.
                      </v-alert>
                    </v-data-table>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
            <v-expansion-panel-content v-else>
              <div class="d-flex justify-center" style="opacity: .5">
                {{ $t("please-save") }}
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>
    </v-layout>

    <Footer></Footer>

    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import { mapState, mapMutations, mapActions } from "vuex";
import { domain, imgPath } from "../services/Constants";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";

export default {
  name: "UpdateProfile",
  components: {
    Header,
    Footer,
    Loading,
  },
  data: () => ({
    check_domain: null,
    validWork: true,
    validEducation: true,
    valid: true,
    lazy: false,
    isLoading: false,
    fullPage: true,
    active_tab: "tab-1",
    tabs: [
      {
        id: 1,
        name: "portfolio_profile",
        icon: "menu_book",
        link: "/profile-portfolio",
      },
      {
        id: 2,
        name: "about",
        icon: "account_circle",
        link: "/profile-about",
      },
    ],
    isMobile: false,
    search: "",
    tab: 2,
    isActiveMainMenu: false,
    worksHeaders: [],
    jobs: ["Test A1", "Test A2", "Test A3"],
    design_type: ["A", "B", "C"],
    userId: null,
    mode: "create",
    http: domain,
    httpImgPath: imgPath,
    profileReload: true,
    coverReload: true,
    btnPersonalIsLoading: false,
    btnEducationIsLoading: false,
    btnWorkIsLoading: false,
    rules: {
      required: (value) => !!value || "Required.",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    },
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    requireRules: [(v) => !!v || "The Field is required"],
    passwordRules: [
      (v) => !!v || "The Field is required",
      (v) => v.length >= 6 || "Value must be at least 6",
    ],
    passwordRules: [
      (v) => !!v || "The Field is required",
      (v) => v.length >= 6 || "Value must be at least 6",
    ],
    domainRules: [
      (v) => !!v || "The Field is required",
      (v) =>
        !/[!@#$%^&*()-+<>?',:;"{}~\\=฿`%|\/\s^\[\]]/.test(v) ||
        "ชื่อโดเมนใช้ได้เฉพาะ ตัวเลข ตัวอักษร จุด ขีดกลาง และ underscore",
    ],
    phoneRules: [
      (v) => !!v || "The Field is required",
      (v) => /^[0-9]*$/.test(v) || "Value must be Number only",
      (v) =>
        (v.length >= 9 && v.length <= 10) ||
        "Value must be between 9-10 character",
    ],
  }),
  async created() {
    this.setWorksHeader();
    if (this.$route.params.id) {
      this.userId = this.$route.params.id;
      await this.onGetProfileInfo(this.userId);
      // check profile available
      if (this.personalInfo.profile_id) {
        this.mode = "update";
        this.onGetAllPortfolioByMemberId(this.userId);
      } else {
        this.mode = "create";
        this.resetPersonalInfo();
      }
    } else {
      this.mode = "create";
      this.resetPersonalInfo();
    }
  },
  computed: {
    ...mapState({
      personalInfo: (state) => state.profile.personalInfo,
      image_profile_facebook: (state) => state.auth.image_profile_facebook,
      allPortfolio: (state) => state.portfolio.allPortfolio,
    }),
    i18n: function() {
      return this.$i18n.locale;
    },
  },
  watch: {
    i18n: function() {
      this.setWorksHeader();
    },
  },
  methods: {
    ...mapMutations("profile", [
      "addEducationInfo",
      "removeEducationInfo",
      "addWorkExperience",
      "removeWorkExperience",
      "resetPersonalInfo",
    ]),
    ...mapActions("profile", [
      "onGetProfileInfo",
      "onUpdateProfileInfo",
      "onCreateProfileInfo",
      "onUploadImage",
    ]),
    ...mapActions("portfolio", [
      "onGetAllPortfolioByMemberId",
      "onDeletePortfolio",
    ]),
    async updatePersonalInfo() {
      if (this.personalInfo.mem_info.domain_name) {
        // ตรวจสอบ Domain
        let res = await axios({
          url: `${domain}api/check-domain?domain=${this.personalInfo.mem_info.domain_name}&profile_id=${this.personalInfo.profile_id}`,
          method: "GET",
        });
        if (res.data.data === "ผ่าน") {
          this.btnPersonalIsLoading = true;
          let param;
          switch (this.mode) {
            case "create":
              if (this.formIsValid()) {
                this.onCreateProfileInfo(this.personalInfo).then(
                  async (res) => {
                    if (res.status === "success") {
                      this.mode = "update";
                      this.userId = res.profile_id;
                      await this.onGetProfileInfo(this.userId);
                      this.btnPersonalIsLoading = false;
                    }
                  }
                );
              } else {
                // alert(this.$t('validate-field'));
                this.$swal({
                  icon: "warning",
                  title: this.$t("validate-field"),
                  confirmButtonColor: "#FD5246",
                  confirmButtonText: "ตกลง",
                });
                this.btnPersonalIsLoading = false;
              }
              break;
            case "update":
              param = {
                id: this.userId,
                data: this.personalInfo,
                update_type: "personal",
              };
              if (this.formIsValid()) {
                this.onUpdateProfileInfo(param)
                  .then(async (res) => {
                    if (res === "success") {
                      this.$swal({
                        icon: "success",
                        text: this.$t("update-success"),
                        confirmButtonColor: "#FD5246",
                        confirmButtonText: "ตกลง",
                      });
                      await this.onGetProfileInfo(this.userId);
                      this.btnPersonalIsLoading = false;
                    }
                  })
                  .catch((e) => {
                    this.$swal({
                      icon: "warning",
                      title: "เกิดข้อผิดพลาด บันทึกไม่สำเร็จ!",
                      text: e.response.data.message,
                      confirmButtonColor: "#FD5246",
                      confirmButtonText: "ตกลง",
                    });
                    this.btnPersonalIsLoading = false;
                  });
              } else {
                this.$swal({
                  icon: "warning",
                  title: this.$t("validate-field"),
                  confirmButtonColor: "#FD5246",
                  confirmButtonText: "ตกลง",
                });
                // alert(this.$t('validate-field'));
                this.btnPersonalIsLoading = false;
              }
              break;
          }
        } else {
          this.$swal({
            icon: "warning",
            text: "Domain นี้ถูกใช้งานไปแล้ว",
            confirmButtonColor: "#FD5246",
            confirmButtonText: "ตกลง",
          });
        }
      } else {
        this.$swal({
          icon: "warning",
          text: this.$t("error-domain"),
          confirmButtonColor: "#FD5246",
          confirmButtonText: "ตกลง",
        });
      }
    },
    updateEducationInfo() {
      if (this.$refs.formEducation.validate()) {
        this.btnEducationIsLoading = true;
        let param = {
          id: this.userId,
          data: this.personalInfo,
          update_type: "education",
        };
        this.onUpdateProfileInfo(param).then(async (res) => {
          if (res === "success") {
            this.$swal({
              icon: "success",
              text: this.$t("update-success"),
              confirmButtonColor: "#FD5246",
              confirmButtonText: "ตกลง",
            });
            await this.onGetProfileInfo(this.userId);
            this.btnEducationIsLoading = false;
          }
        });
      }
    },
    updateWorkInfo() {
      if (this.$refs.formWork.validate()) {
        this.btnWorkIsLoading = true;
        let param = {
          id: this.userId,
          data: this.personalInfo,
          update_type: "work",
        };
        this.onUpdateProfileInfo(param).then(async (res) => {
          if (res === "success") {
            this.$swal({
              icon: "success",
              text: this.$t("update-success"),
              confirmButtonColor: "#FD5246",
              confirmButtonText: "ตกลง",
            });
            await this.onGetProfileInfo(this.userId);
            this.btnWorkIsLoading = false;
          }
        });
      }
    },
    formIsValid() {
      if (
        this.dataIsCorrect(this.personalInfo.name_th) &&
        this.dataIsCorrect(this.personalInfo.last_th) &&
        // this.dataIsCorrect(this.personalInfo.email) &&
        this.dataIsCorrect(this.personalInfo.domain_name)
      ) {
        return true;
      } else {
        return false;
      }
    },
    dataIsCorrect(data) {
      return data !== null && data !== "";
    },
    onSelectProfile(size = "mobile") {
      if (size === "mobile") {
        // if (!this.isMobile()){
        this.$refs.profile.click();
        // }
      }
    },
    onSelectCover(size = "mobile") {
      if (size === "mobile") {
        this.$refs.cover.click();
      }
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    // isMobile() {
    //   if (
    //     /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    //       navigator.userAgent
    //     )
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    async onProfileChanged(e) {
      if (e.target.files[0]) {
        this.isLoading = true;
        this.profileReload = false;
        let param = { image: e.target.files[0], type: "profile" };
        await this.onUploadImage(param).then(() => {
          this.isLoading = false;
        });
        this.profileReload = true;
      }
    },
    async onCoverChanged(e) {
      if (e.target.files[0]) {
        this.isLoading = true;
        this.coverReload = false;
        let param = { image: e.target.files[0], type: "cover" };
        await this.onUploadImage(param).then(() => {
          this.isLoading = false;
        });
        this.coverReload = true;
      }
    },
    onEdit(id) {
      this.$router.push({ name: "EditPortfolio", params: { id: id } });
    },
    onDelete(id) {
      this.$swal({
        title: this.$t("confirm-delete"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#FD5246",
        cancelButtonColor: "#525252",
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("cancle"),
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.onDeletePortfolio(id)
            .then((res) => {
              if (res.status === 200) {
                this.$swal({
                  icon: "success",
                  title: this.$t("delect-portfolio-success"),
                  confirmButtonColor: "#FD5246",
                  confirmButtonText: "ตกลง",
                });
                this.isLoading = false;
                this.onGetAllPortfolioByMemberId(this.userId);
              }
            })
            .catch((e) => {
              this.$swal({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                text: "ลบข้อมูลไม่สำเร็จ",
                confirmButtonColor: "#FD5246",
                confirmButtonText: "ตกลง",
              });
              this.isLoading = false;
            });
        }
      });
    },
    setWorksHeader() {
      this.worksHeaders = [
        { text: this.$t("port-name"), value: "name" },
        { text: this.$t("category"), value: "category" },
        { text: this.$t("img-desc"), value: "description" },
        { text: this.$t("updated-at"), value: "updated_at" },
        { text: this.$t("edit"), value: "action" },
      ];
    },

    checkImage(val, type) {
      if (val) {
        switch (type) {
          case "avatar":
            if (val.avatar) {
              return (
                this.http + this.httpImgPath + "images_profile/" + val.avatar
              );
            } else {
              if (this.image_profile_facebook) {
                return this.image_profile_facebook;
              } else {
                return require("../assets/user_profile.png");
              }
            }
            break;
          case "cover_url":
            return val.cover_url
              ? this.http +
                  this.httpImgPath +
                  "images_profile_cover/" +
                  val.cover_url
              : require("../assets/cover.png");
            break;
        }
      } else {
        return require("../assets/user_profile.png");
      }
    },
    async checkDomain() {
      // console.log(this.personalInfo.mem_info.domain_name);
      const regex = /[\\\/\][\s]/;
      const matches = regex.exec(this.personalInfo.mem_info.domain_name);
      if (matches) {
        this.$swal({
          icon: "warning",
          text: "ชื่อ domain จะต้องไม่มี / หรือ ช่องว่าง",
          confirmButtonColor: "#FD5246",
          confirmButtonText: "ตกลง",
        });
      } else {
        if (this.personalInfo.mem_info.domain_name) {
          let res = await axios({
            url: `${domain}api/check-domain?domain=${this.personalInfo.mem_info.domain_name}&profile_id=${this.personalInfo.profile_id}`,
            method: "GET",
          });
          if (res.data.status === 200) {
            this.$swal({
              icon: "success",
              text: "Domain นี้ใช้งานได้",
              confirmButtonColor: "#FD5246",
              confirmButtonText: "ตกลง",
            });
          } else {
            this.$swal({
              icon: "warning",
              text: "Domain นี้ถูกใช้งานไปแล้ว",
              confirmButtonColor: "#FD5246",
              confirmButtonText: "ตกลง",
            });
          }

          return res.data;
        } else {
          this.$swal({
            icon: "warning",
            text: this.$t("error-domain"),
            confirmButtonColor: "#FD5246",
            confirmButtonText: "ตกลง",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
/*.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)*/
/*> .v-expansion-panel--active {*/
/*    border-radius: 10px;*/
/*}*/

/*.v-btn:not(.v-btn--round).v-size--default {*/
/*    min-width: unset;*/
/*}*/

.removeBtnPos {
  right: -40px;
  top: 33px;
}

.addBtnPos {
  right: -40px;
  top: 25px;
}

.left-sm-and-up {
  left: -1.8%;
}

.left-xs {
  left: -2.5%;
}

.hover_img {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.6;
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  .v-data-table-header {
    border-top: 1px solid #000;
    display: none;
  }
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
</style>
